module.exports = __webpack_public_path__ + "img/csm_Ersa-Selective-CAD-Assistant-4-01-900x675_b17efdfbf7.bd46c094.jpg";